import { AUTH_USER, AUTH_ERROR, SET_CODE_VERIFIER, SET_AUTH_STATE, AUTH_LOGOUT } from 'helpers/types';

const INITIAL_STATE = {
  authenticated: '',
  errorMsg: null,
  codeVerifier: '',
  authState: '',
  deviceToken: '',
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case AUTH_USER:
      sessionStorage.setItem('authenticated', action.payload);
      return {
        ...state,
        authenticated: action.payload,
      };
    case AUTH_ERROR:
      return {
        ...state,
        errorMsg: action.payload,
      };
    case SET_CODE_VERIFIER:
      sessionStorage.setItem('codeVerifier', action.payload);
      return {
        ...state,
        codeVerifier: action.payload,
      };
    case SET_AUTH_STATE:
      sessionStorage.setItem('authState', action.payload);
      return {
        ...state,
        authState: action.payload,
      };
    case AUTH_LOGOUT:
      const uuid = sessionStorage.getItem('deviceToken');
      sessionStorage.clear();
      sessionStorage.setItem('deviceToken', uuid);
      return {
        ...state,
        authenticated: '',
        errorMsg: null,
      };
    default:
      return state;
  }
}
